export default "__VITE_ASSET__BD07qwCt__"